import cubejs from '@cubejs-client/core';
import Vue from 'vue';
import { getBaseURL } from '@/services/api/internal/tools/client';

const apiUrl = `${getBaseURL()}/p2c_stats/api/v1`;

const cubejsGraphApi = cubejs(async () => Vue.prototype.$auth.getIdToken(), {
  apiUrl,
  pollInterval: '120',
});

export default cubejsGraphApi;
